import React from 'react';

import { ISearchFilter, ISearchFilterRangeOption } from '../../../../../context/search/types';

import useSearch from '../../../../../context/search/useSearch';
import Money from '../../../../Money';
import DualRangeSlider from '../../../../RangeSliders/DualRangeSlider';


interface IMultiOptionFilter {
  filterIndex: number,
  filter: ISearchFilter,
}

/*
 * 
 * @param filterIndex
 * @param filter
 * @constructor
 */


const RangeOptionFilter: React.FC<IMultiOptionFilter> = ({filterIndex, filter}): JSX.Element => {

  const {inputEventHandlers} = useSearch()


  return (
    <React.Fragment>

      
      <div className={'sf-search-filter-range-options'}>
        {
          (filter.options as ISearchFilterRangeOption[]).map((option: ISearchFilterRangeOption, index) => {
            return (
              <React.Fragment key={index}>
                <DualRangeSlider
                  range={[parseInt(option.minimum), parseInt(option.maximum)]}
                  values={[parseInt(option.selectedMinimum), parseInt(option.selectedMaximum)]}
                  onChange={(vals) => inputEventHandlers.handleUpdateRangeOption(filterIndex, index, vals[0], vals[1])}>
                  {({ value, labelHandle }) => <span><label>{ labelHandle }: </label><Money amount={value * 100} /></span>}
                </DualRangeSlider>
              </React.Fragment>
            )
          })}
      </div>
    </React.Fragment>
  )
}

export default RangeOptionFilter